import { css } from "@emotion/css";
import MuiTab, { tabClasses } from "@mui/material/Tab";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import { forwardRef } from "react";
import type { ReactNode } from "react";
export interface TabProps {
    label: ReactNode;
    value: string;
    disabled?: boolean;
    tabIndex?: number;
    children?: React.ReactNode;
}
export const Tab = forwardRef<HTMLDivElement, TabProps>(({ label, value, disabled, tabIndex, children, ...props }, ref) => {
    // We need to spread the props here otherwise the tab would not navigate when clicking, MUI injects extra props from parent Tabs component so that the onChange in Tabs could be called when tab is clicked.
    return <MuiTab ref={ref} classes={{ root: tabRootStyles, disabled: tabDisabledStyles }} {...props} label={label} value={value} disabled={disabled} tabIndex={tabIndex} disableTouchRipple disableRipple/>;
});
Tab.displayName = "Tab";
const tabRootStyles = css({
    [`&.${tabClasses.root}`]: {
        minWidth: "7.23rem", // Needed for DrawerWrapperLayout.
        textTransform: "none",
        minHeight: "unset",
        font: text.body.bold.medium,
        textOverflow: "ellipsis",
        color: themeTokens.color.text.secondary,
        flexDirection: "row",
        padding: `${space[12]} ${space[24]}`,
        justifyContent: "center",
        alignItems: "center",
        display: "inline-flex",
        gap: space[8],
        [":hover"]: {
            backgroundColor: themeTokens.color.background.primary.hover,
        },
        [`&.${tabClasses.selected}`]: {
            color: themeTokens.color.text.selected,
        },
    },
});
const tabDisabledStyles = css({
    [`&.${tabClasses.root}.${tabClasses.disabled}`]: {
        color: themeTokens.color.text.disabled,
    },
});
